import './../sass/main.scss';
var $ = require('jquery');

// seconds to timestring helper function
var timeString = (secs) => {
    let ss = Math.floor(secs),
        hh = Math.floor(ss / 3600),
        mm = Math.floor((ss - hh * 3600) / 60);

    ss = ss - hh * 3600 - mm * 60;
    if (hh > 0) {
        mm = mm < 10 ? "0" + mm : mm;
    }
    ss = ss < 10 ? "0" + ss : ss;
    return hh > 0 ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;
};

$(function(){

    // Animate pixel image
    $('.pixels').on('mouseenter touchstart', '.on', function() {
        $(this).removeClass('on');
    });

    var test = true;

    setInterval(function() {
        if($('.pixels span:not(.p0):not(.on)').length > 100) {
            let l = Math.floor(Math.random() * $('.pixels span:not(.p0):not(.on)').length);
            $('.pixels span:not(.p0):not(.on)').eq(l).addClass('on');
        }
    }, 20);

    setInterval(function() {
        if($('.pixels span:not(.p0).on').length) {
            let l = Math.floor(Math.random() * $('.pixels span:not(.p0).on').length);
            $('.pixels span:not(.p0).on').eq(l).removeClass('on');
        }
    }, 60);


    // Add bigger holes in pixel design (disabled)
    /*
        var start = 16000;
        if(test) {
            $('.pixels span').addClass('on');
            start = 10;
        }

        setTimeout(function() {
            setInterval(function() {
                let o = 100;
                for(let i=0; i<16; i++) {
                    if($('.pixels span').length > o+o) {
                        let l = Math.floor(Math.random() * ($('.pixels span').length -o -o)) +o;
                        for(let index of [-96,-49,-48,-47,-2,-1,0,1,2,47,48,49,96]) {
                            $('.pixels span').eq(l+index).removeClass('on');
                        }
                    }
                }
            }, 2000);
        }, start);
    */


    // Open links in new tab, unless mobile
    if($(window).width() >= 768) {
        $('a').attr('target', '_blank');
    }


    // Check if device needs charging
    if('getBattery' in navigator) {
        navigator.getBattery().then(function(battery) {
            if(battery.charging !== true && battery.level <= 0.15) {
                $('h1 span').text('please charge your phone');
            }
        });
    }


    // Music player
    var player = {
        audio:   new Audio($('.js-player').attr('data-music')),
        seeking: false
    };

    player.audio.onloadstart = () => {
        $('.js-player [data-time]').text('0:00');
    };

    player.audio.onloadedmetadata = () => {
        $('.js-player [data-time]').text('0:00');
        $('.js-player [data-scrub]').attr('max',Math.floor(player.audio.duration));
        player.audio.volume = 1;

        $('.js-player [data-scrub]').on('input', function() {
            player.seeking = true;
        }).on('change', function() {
            player.audio.currentTime = $(this).val();
            if(!player.audio.paused) {
                player.audio.play();
            }
            player.seeking = false;
        });
    }

    player.audio.ontimeupdate = () => {
        if(!player.seeking) {
            $('.js-player [data-scrub]').val(Math.floor(player.audio.currentTime));
        }
        $('.js-player [data-time]').text(timeString(player.audio.currentTime));
        let scrubPosition = Math.min(95, Math.floor(100 * $('.js-player [data-scrub]').val() / $('.js-player [data-scrub]').attr('max')));
        $('.js-player [data-scrubber]').css('width', scrubPosition + '%');
    }

    player.audio.oncanplaythrough = () => {
        $('.js-player [data-action], .js-player [data-scrub]').attr('disabled', false);
    }

    player.audio.onwaiting = () => {
        $('.js-player [data-action], .js-player [data-scrub]').attr('disabled', true);
    }

    $('.js-player [data-action]').on('click', function(ev) {
        console.log($(this));
        switch($(this).attr('data-action')) {
            case 'play':
                player.audio.play();
                $(this).attr('data-action', 'pause');
                break;
            //end case;

            case 'pause':
                player.audio.pause();
                $(this).attr('data-action', 'play');
                break;
            //end case;
        }
    });

    $('.js-player [data-scrub]').on('input', function(ev) {
        let scrubPosition = Math.min(95, Math.floor(100 * $(this).val() / $(this).attr('max')));
        $('.js-player [data-scrubber]').css('width', scrubPosition + '%');
    });
});
